<div id="breadcrumbs-desktop" class="breadbrumbs-wrapper" fxLayoutAlign="start center" fxLayout="row">
  <ul class="breadcrumb">
    <ng-container *ngFor="let breadcrumb of breadcrumbs;let last=last ">
      <li *ngIf="breadcrumb.label">
        <ng-container *ngIf="!last else nonactivelink">
          <a *ngIf="breadcrumb.url else nonactivelink" [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
        </ng-container>
        <ng-template #nonactivelink>
          <span>{{ breadcrumb.label }}</span>
        </ng-template>
      </li>
    </ng-container>
  </ul>
</div>